import {
  GET_MENU_CATEGORIES_RESPONSE,
  GET_MENU_CATEGORIES_ERROR,
  GET_MENU_CATEGORIES_REQUEST,
} from 'actions/menuCategories';

const backupState = [
  { slug: 'meal-kits', title: 'Meal Kits', description: '' },
  { slug: 'fifteen-minute-kits', title: '15 Minute Meal Kits', description: '' },
  { slug: 'easy-prep-kits', title: 'Easy Prep Meal Kits', description: '' },
  { slug: 'extras', title: 'Extras', description: '' },
];

const initialState = {
  loading: false,
  failed: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_CATEGORIES_REQUEST:
      return {
        ...state,
        failed: false,
        loading: true,
      };
    case GET_MENU_CATEGORIES_RESPONSE:
      return {
        ...state,
        loading: false,
        data: action.response.menuCategories,
      };
    case GET_MENU_CATEGORIES_ERROR:
      return {
        ...state,
        loading: false,
        failed: true,
        data: backupState,
      };
    default:
      return state;
  }
};

export const selectMenuCategoriesLoading = state => state.loading;
export const selectMenuCategoriesData = state => state.data;
